import React from 'react';

import {
  convertLocationParamsToFetchParams,
  usePolicies,
} from 'app/policies/api';
import {QuizGenericObjectsSidebar} from 'app/quizzes/components/QuizDetailPage/QuizGenericObjectsSidebar';
import {POLICIES_NEW_POLICY} from 'app/urls';

import type {LinkedDocumentType, QuizSerializedType} from 'sweet-types';

interface Props {
  quiz: QuizSerializedType;
  attachedItems: Array<LinkedDocumentType>;
}

export function QuizPoliciesSidebar({quiz, attachedItems}: Props) {
  return (
    <QuizGenericObjectsSidebar
      quizId={quiz.id}
      contentType={'policy'}
      quizURL={quiz.url}
      closeUrl={quiz.html_url}
      attachedItems={attachedItems}
      createURL={POLICIES_NEW_POLICY}
      useDataHook={usePolicies}
      paramsConverter={convertLocationParamsToFetchParams}
      canEdit={quiz.can_edit}
    />
  );
}
